<template>
    <div v-if="item !== null">
        <h2 class="title">{{ item.name }}</h2>
        <div class="columns">
            <div class="column is-6">
                <item-form :item="item" @saved="reloadItem"></item-form>
            </div>
            <div class="column is-6">
                <h2 class="subtitle">Products containing this item</h2>
                <div v-for="product in linkedProducts">
                    <router-link :to="{ name: 'product', params: {id: product.id}}">
                        {{ product.name }}
                    </router-link>
                </div>
                <br/>
                <a>Add this item to a product...</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                item_id: parseInt(this.$route.params.id),
                item: null
            }
        },
        computed: Object.assign({}, mapGetters(['items', 'products']), {
            linkedProducts() {
                let links = this.$store.state.products.product_items.filter(item => item.item_id === this.item_id)
                let ids   = []
                for (let link in links) {
                    ids.push(links[link].product_id)
                }

                return this.products.filter(product => ids.indexOf(product.id) !== -1)
            },
        }),
        mounted() {
            this.reloadItem();
        },
        methods: {
            changeTag(newId, oldId) {
                this.item_id = parseInt(newId)
                this.reloadItem()
            },
            reloadItem() {
                this.item = null;
                setTimeout(() => {
                    this.item = this.items.find(item => item.id === this.item_id)
                })
            }
        },
        watch: {
            '$route.params.id': 'changeItem'
        }
    };
</script>



// WEBPACK FOOTER //
// ItemEdit.vue?7284677c